if ( typeof listGuide !== 'function' ) {

	class listGuide extends HTMLElement {

		constructor(){
			super();
		}
	}

	if ( typeof customElements.get('list-guide') == 'undefined' ) {
		customElements.define('list-guide', listGuide);
	}
}

// 로그인모달 -> 함수 바로 실행
window.addEventListener('load', () => {
	const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('listGuide') === 'true') {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('listGuide');
        window.history.replaceState({}, '', newUrl);
        loadAndOpenModal();
    }
})

document.addEventListener('DOMContentLoaded', () => {
	searchProductCode();
	showCategoryGuide();

	howtocheckBadgeModal();
	document.querySelector('.list-guide-badge.badge-right').addEventListener('click', () => {
		if(!customerMd5Hash){
			commonLoginModal('listGuide');
		} else {
			loadAndOpenModal();
		}
	});

	const prevAdditionalAction = sessionStorage.getItem("prev_additional_action");
    const saveModal = sessionStorage.getItem("oneToOneModal");

    if(prevAdditionalAction == "true" && saveModal == 'true'){
        if (window.isLoggedIn) {
            callModal();
            sessionStorage.removeItem("prev_additional_action");
            sessionStorage.removeItem("oneToOneModal");
        }
    }
});

// 제품 가이드 검색 관련
function searchProductCode() {

	const search_input = document.getElementById('guide-search-input');
	const search_delete_btn = document.querySelector('.guide-search-delete');
	const search_btn = document.querySelector('.guide-search-btn');

	// 인풋 텍스트 지우기 버튼 상태
	search_input.addEventListener('input', () => {
		if (search_input.value == '') {
			search_delete_btn.classList.add('hidden');
		} 
		else {
			search_delete_btn.classList.remove('hidden');
		}
	});

	// 인풋 엔터
	search_input.addEventListener('keydown', (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			search_btn.click();
		}
	});

	// 인풋 텍스트 지우기
	search_delete_btn.addEventListener('click', () => {
		search_input.value = '';
		search_delete_btn.classList.add('hidden');
	});

	// 검색 버튼
	search_btn.addEventListener('click', () => {
		let searchCode = document.getElementById('guide-search-input').value.trim();
		findIndexProduct(searchCode);
	});
}

// 제품 코드로 가이드 상품 찾기
function findIndexProduct(searchCode) {
	closeAlertModal(); 
	window.location.href = `/pages/product-guide-result?productCode=${searchCode}&searchbar=true`;
}

// 카테고리별 제품가이드 리스트 변경
function showCategoryGuide() {

	const category_list = document.querySelectorAll('.guide-category-item');
	const guide_list = document.querySelectorAll('.list-guide-grid-cell');

	category_list.forEach((category) => {
		category.addEventListener('click', () => {

			// 카테고리 CSS
			category_list.forEach((list) => list.classList.remove('category-active'));
			category.classList.add('category-active');

			// 가이드 CSS
			let collection = category.dataset.collection;

			guide_list.forEach((guide) => {
				guide.classList.add('hidden');

				if(collection == "all" | guide.dataset.parents == collection) {
					guide.classList.remove('hidden');
				}
			})
		});
	})
}

// 뱃지 - 제품코드 확인 방법
function howtocheckBadgeModal() {

	const howtocheckBadge = document.querySelector('.list-guide-badge.badge-left');

	let modalContent = `
		<div class="list-code-modal-container">
			<div class="list-code-modal">
				<div class="list-code-modal-img">
					<img src="${img_product_code}" alt="img_product_ex" />
				</div>
				<div class="list-code-modal-sub-wrapper">
					<div class="list-code-modal-sub">
						<img src="${icon_bulleted_list}" alt="icon_bulleted_list" />
						제품 하부에 부착된 품질표시 스티커에서 제품 코드를 확인하세요.
					</div>
					<div class="list-code-modal-sub">
						<img src="${icon_bulleted_list}" alt="icon_bulleted_list" />
						제품 코드는 숫자+영문으로 구성되어 있습니다.
					</div>
				</div>
			</div>
		</div>`;

	howtocheckBadge.addEventListener('click', () => {
		openModalWithContent("제품 코드 확인", modalContent, () => {
			document.getElementById("site-alert-modal").classList.add("height-auto--modal");
			let modalContents = document.querySelector('.modal--contents');
			if(modalContents) {
				modalContents.removeAttribute('style'); // 인라인 스타일 제거
			}
		});
	})
}

// 뱃지 - 나의 등록 제품으로 조회
async function loadAndOpenModal() {

	const badgeRight = document.querySelector('.list-guide-badge.badge-right');
	let productData = [];
	let temp = ``;
	let modalContent = `
		<div class="list-code-modal-container list-my-product-modal">
			<div id="list-my-product" class="list-code-modal">
			</div>
		</div>`;
	
	try {
		badgeRight.style.pointerEvents = "none";
		productData = await fetchMyRegisteredProduct();
		badgeRight.style.pointerEvents = "auto";

		if(productData && productData.length > 0) {
			let productFullName = "";
			let representativeImage = "";
			let verifyDate = "";

			for (let i = 0; i < productData.length; i++) {

				let matchIndex = allData.findIndex((product) => {
					return product.variants.some((item) => {
						let itemSku = item.sku.split('-')[0];
						return productData[i].itmCd == itemSku;
					});
				});

				// productFullName = modifyData("productFullName", productData[i].productFullName);
				// representativeImage = (productData[i].representativeImage && productData[i].representativeImage != 'N/A' ) ? `url('${productData[i].representativeImage}')`:'none';
				if(matchIndex == -1) {
					// 정보 없음 - API 정보 사용
					productFullName = modifyData("productFullName", productData[i].productFullName);
					representativeImage = (productData[i].representativeImage && productData[i].representativeImage != 'N/A' ) ? `url('${productData[i].representativeImage}')`:`url('${no_product_image}')`;
				}
				else {
					// 정보 있음 - 찾은 거 사용
					productFullName = modifyData("productFullName", allData[matchIndex].title);
					representativeImage = (allData[matchIndex].variants[0].image && allData[matchIndex].variants[0].image != 'N/A' ) ? `url('${allData[matchIndex].variants[0].image}')`:`url('${no_product_image}')`;
				}
				verifyDate = modifyData("verifyDate", productData[i].verifyDate);

				temp += `
					<div class="list-my-product-container" onclick="findIndexProduct('${productData[i].itmCd}', event)">
				
						<div class="list-my-product-img" style="background-image: ${representativeImage};">
						</div>
		
						<div class="list-my-product-text">
							<div class="list-my-product-title">${productFullName}</div>
		
							<div class="list-my-product-text-sub">
								<div class="list-desc">
									<div class="list-left">색상코드</div>
									<div class="list-right">${productData[i].colCd}</div>
								</div>
								<div class="list-desc">
									<div class="list-left">품질보증기간</div>
									<div class="list-right">${verifyDate}까지</div>
								</div>
								<div class="list-desc">
									<div class="list-left">시리얼넘버</div>
									<div class="list-right">${productData[i].serialNumber}</div>
								</div>
							</div>
		
							<div class="list-my-product-text-bottom">
								<div class="list-desc">
									<div class="list-left">제품코드</div>
									<div class="list-right-code">${productData[i].itmCd}</div>
								</div>
								<div class="list-btn">
									제품가이드 보기
								</div>
							</div>
						</div>
		
					</div>`;
			}
		}
		else {
			temp += `
				<div class="guide-no-product-container">
					<div class="guide-no-product">제품을 등록하고 시디즈의 다양한 혜택과 지원을 받아보세요.</div>
					<div class="guide-no-product-btn">정품 등록하기</div>
				</div>
			`;
		}

		openModalWithContent("내가 등록한 제품 코드", modalContent, () => {
			const listMyProduct = document.getElementById('list-my-product');
			listMyProduct.insertAdjacentHTML('beforeend', temp);
			if(document.querySelector('.guide-no-product-btn')) {
				document.querySelector('.guide-no-product-btn').addEventListener('click', openProductRegisterModal);
			}
		});
	} 
	catch (error) {
		console.error(error);
		badgeRight.style.pointerEvents = "auto";

		temp = '';
		temp += `
			<div class="guide-no-product-container">
				<div class="guide-no-product">제품을 등록하고 시디즈의 다양한 혜택과 지원을 받아보세요.</div>
				<div class="guide-no-product-btn">정품 등록하기</div>
			</div>
		`;

		openModalWithContent("내가 등록한 제품 코드", modalContent, () => {
			const listMyProduct = document.getElementById('list-my-product');
			listMyProduct.insertAdjacentHTML('beforeend', temp);
			if(document.querySelector('.guide-no-product-btn')) {
				document.querySelector('.guide-no-product-btn').addEventListener('click', openProductRegisterModal);
			}
		});
	}
}

function fetchMyRegisteredProduct() {
  return fetch("https://sidiz-shopify.fursys.com/v1/db/customer-prod-verification-list", {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
			"customerMd5Hash": customerMd5Hash
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((error) => {
        throw new Error(error.response_message || "알 수 없는 오류가 발생했습니다.");
      });
    }
    return response.json();
  })
}

// 데이터 처리
function modifyData(name, value) {

	if(name == "productFullName") {
		if(!value || value == "N/A") {
			productFullName = "";
		}
		else {
			productFullName = value;
		}
		return productFullName;
	}
	else if(name == "representativeImage") {
		if(!value || value == "N/A") {
			// representativeImage = "대체 이미지 자리";
			representativeImage = "";
		}
		else {
			representativeImage = value;
		}
		return representativeImage;
	}
	else if(name == "verifyDate") {
		if(value) {
			verifyDate = value.split('T')[0];
		}
		else {
			verifyDate = "";
		}
		return verifyDate;
	}
}